export const wellKnownConfigurationUri = '/.well-known/openid-configuration';

export interface OpenIdConfiguration {
  token_endpoint: string;
  userinfo_endpoint: string;
}
